import type { RootState } from '@/store';

// UI State Selectors
export const selectSearchTerm = (state: RootState) => state.personnel.searchTerm;

export const selectIsModalOpen = (state: RootState) => state.personnel.isModalOpen;

export const selectSelectedPersonnelId = (state: RootState) => state.personnel.selectedPersonnelId;

export const selectModalMode = (state: RootState) => state.personnel.modalMode;

export const selectSortField = (state: RootState) => state.personnel.sortField;

export const selectSortOrder = (state: RootState) => state.personnel.sortOrder;

// Note: Personnel data is now fetched via RTK Query (useGetPersonnelsQuery)
// Client-side filtering removed - server-side search is used instead
